export enum AbsenceLimitScalingStrategyEnum {
  None = 0,
  ScaleByWorkingTimeFractionFloor = 1,
}
